<div class="welcome-conatiner" style="height: 100vh; overflow-y: hidden;">
  <header class="header">
    <div class="header-container">
      <div class="left-section">
        <a href="https://www.tatamotors.com/" target="_blank">
        <img height="32px"
        [src]='environment1 + "assets/images/better_always_dark.png"'
          alt="TATA MOTORS COMMERCIAL VEHICLES"
          class="logo-left"
          />
         </a>

      </div>

      <img  height="32px"
      [src]='environment1 + "assets/images/osp_logo_dark.png"'
        alt="TATA MOTORS Fleetverse"
        class="logo-center"
      />

    <a href="https://www.tata.com/" target="_blank">
      <img height="32px"
      [src]='environment1 + "assets/images/tatalogo_black.svg"'
        alt="TATA"
        class="logo-right"
      />
    </a>
    </div>
  </header>
  <div class="welcome-wrapper">

    <div class="background-image">

      <button class="cancel-icon" (click)="onExplorePageClick()">
        <img [src]='environment1 + "assets/images/close_new.png"' alt="Cancel">
      </button>
      <img [src]='environment1 + "assets/images/Square T.svg"' class="t-image" alt="T">
      <div class="horizontal-line"></div>
      <div class="vertical-line"></div>
      <div class="bottom-horizontal-line"></div>
      <div class="bottom-vertical-line"></div>
      <div class="button-container">
        <!-- <h4 class="button-heading">Select one option to continue</h4> -->
        <div class="buttons">
          <button class="custom-btn" (click)="onExplorePageClick()">
            <img [src]='environment1 + "assets/images/explore-Truck.png"' alt="Explore Icon"> Explore our Products
          </button>
          <button class="custom-btn" (click)="onBuildNowClick()">
            <img [src]='environment1 + "assets/images/build-Truck.png"' alt="Build Icon"> Build your own vehicle
          </button>
        </div>
      </div>

    </div>
  </div>
